var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5V9C16 8.4 15.6 8 15 8C14.4 8 14 8.4 14 9V12.5C14 13.9 12.9 15 11.5 15H4.5C3.1 15 2 13.9 2 12.5V5.5C2 4.1 3.1 3 4.5 3H8C8.6 3 9 2.6 9 2C9 1.4 8.6 1 8 1H4.5C2 1 0 3 0 5.5V12.5C0 15 2 17 4.5 17H11.5C14 17 16 15 16 12.5Z",
    fill: "#C1C5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6V1C17 0.9 17 0.7 16.9 0.6C16.8 0.4 16.6 0.2 16.4 0.0999999C16.3 -9.68575e-08 16.1 0 16 0H11.2C10.6 0 10.2 0.4 10.2 1C10.2 1.6 10.6 2 11.2 2H13.6L7.3 8.3C6.9 8.7 6.9 9.3 7.3 9.7C7.5 9.9 7.8 10 8 10C8.2 10 8.5 9.9 8.7 9.7L15 3.4V6C15 6.6 15.4 7 16 7C16.6 7 17 6.6 17 6Z",
    fill: "#C1C5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.8a62a2c0.svg";
export { ForwardRef as ReactComponent };